import {
  LOG_URL,
  LOG_DEBUG_URL
} from 'shared/utils/Constants';

import {
  post
} from 'shared/services/ApiService';

export const PORTAL_SOURCE = 0;
export const PWA_SOURCE = 1;
export const KIOSK_SOURCE = 2;
export const MLB_SOURCE = 3;
export const SHARE_SOURCE = 4;

export const logError = (source, error) => {
  console.error(error);

  let params = {
    source: source,
    url: window.location.toString(),
    file_name: error.fileName,
    line_number: error.lineNumber,
    column_number: error.columnNumber,
    message: error.message,
    stack: error.stack
  }

  return post(LOG_URL, params);
}

export const logPortalError = (error, info) => {
  return logError(PORTAL_SOURCE, error, info);
}

export const logPWAError = (error, info) => {
  return logError(PWA_SOURCE, error, info);
}

export const logKioskError = (error, info) => {
  return logError(KIOSK_SOURCE, error, info);
}

export const logMLBError = (error, info) => {
  return logError(MLB_SOURCE, error, info);
}

export const logShareError = (error, info) => {
  return logError(SHARE_SOURCE, error, info);
}

export const logDebug = payload => {
  post(LOG_DEBUG_URL, payload);
}
